import React, { useEffect, useRef, useState } from 'react';
import './UserProfileModal.css';
import { useAuth } from '../hooks/useAuth';

const ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin' },
  { value: 'csm', label: 'Customer Success Manager' },
  { value: 'viewer', label: 'Viewer' },
];

const UserProfileModal = ({ isOpen, onClose }) => {
  const { user, saveProfile } = useAuth();
  const [displayName, setDisplayName] = useState('');
  const [avatarPreview, setAvatarPreview] = useState('');
  const [role, setRole] = useState('csm');
  const [saving, setSaving] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen && user) {
      setDisplayName(user.name || '');
      setAvatarPreview(user.picture || '');
      setRole(user.role || 'csm');
    }
  }, [isOpen, user]);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setAvatarPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    if (!user) return;
    setSaving(true);
    try {
      await saveProfile({ name: displayName, picture: avatarPreview, role });
      onClose?.();
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="profile-modal-backdrop" role="dialog" aria-modal="true">
      <div className="profile-modal">
        <div className="profile-modal-header">
          <h3>My Profile</h3>
          <button className="profile-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="profile-modal-body">
          <div className="avatar-section">
            <div className="avatar-preview">
              {avatarPreview ? (
                <img src={avatarPreview} alt={displayName} />
              ) : (
                <div className="avatar-fallback">{user?.initials}</div>
              )}
            </div>
            <div className="avatar-actions">
              <button className="btn-secondary" onClick={() => fileInputRef.current?.click()}>Change photo</button>
              <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} />
              {avatarPreview && (
                <button className="btn-secondary" onClick={() => setAvatarPreview('')}>Remove</button>
              )}
            </div>
          </div>

          <div className="field">
            <label htmlFor="displayName">Display name</label>
            <input id="displayName" value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder="Your name" />
          </div>

          <div className="field">
            <label htmlFor="role">Role</label>
            <select id="role" value={role} onChange={(e) => setRole(e.target.value)}>
              {ROLE_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="profile-modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : 'Save changes'}</button>
        </div>
      </div>
    </div>
  );
};

export default UserProfileModal; 